/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/auth/sso",
    },
    (router) => {
      router.push({
        id: "@api/auth.sso@redirect",
        path: "/redirect",
      });

      router.push({
        id: "@api/auth.sso@callback",
        path: "/callback",
      });
    },
  );
}
